module.exports = __webpack_public_path__ + "assets/img/2.82d43c32.png";